import { RetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

const isIneligibleRetailer = () => {
  // If the retailer has ever had an active sub user, we don't want to bucket them.
  if (RetailerStore.get().hasEverHadActiveSubUser) {
    return true;
  }

  // If the retailer has never placed an order, we don't want to bucket them.
  if (!RetailerStore.get().hasPlacedFirstOrder) {
    return true;
  }

  return false;
};

export const getSettingMultiUserGTMV2 = (): boolean => {
  if (isIneligibleRetailer()) {
    return false;
  }

  return true;
};

export const getSettingMultiUserGTMV2NoConstraints = () => {
  if (RetailerStore.get().hasEverHadActiveSubUser) {
    return false;
  }

  return true;
};

// This method removes the constraint of the retailer having placed an order. It is used for some GTM surface areas.
export const getSettingMultiUserGTMV2NoConstraintsAndAssign = () => {
  if (RetailerStore.get().hasEverHadActiveSubUser) {
    return false;
  }

  return true;
};
